import { unitMapping, type Unit } from '#src/lib/style.ts';
import type { Color } from '#src/style/types.ts';

type Props = {
  size?: Unit;
  color?: Color;
};

export const FlameFilled = ({ size = 2, color }: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    style={{ width: unitMapping[size], height: unitMapping[size] }}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.3049 0.233643L11.0941 1.24438L11.0934 1.32935L16.7193 9.15894L17.737 8.50562L17.8298 8.71289L18.2177 9.39258L18.2015 9.4021L20.7436 13.8472L20.7935 19.8904L16.8198 22.2209L16.8072 22.1763L13.7894 24L12.3051 17.209L9.40882 15.7375L7.49088 21.7361L3 15.7375V4.68237L3.0499 4.73584L5.64674 3.06665V2.98022L5.69664 3.03442L5.70859 3.02783L6.60957 3.99902V4.01514L7.45082 4.91968V1.7168L10.1229 0L10.1369 0.0183105V0L10.3049 0.233643ZM8.38414 2.25952V2.94434L15.0565 12.2292V10.2297L18.0975 15.5493V20.3547L19.8552 19.3242L19.8123 14.1189L17.3996 9.90015L15.5316 11.0596L15.0502 10.218L15.9245 9.67529L10.1566 1.64868V1.58423L9.91554 1.27515L8.38414 2.25952ZM3.96986 5.28662V5.72461L6.56811 8.5188L6.57935 8.52319V8.52979L7.49088 9.5105V6.35889L5.67626 4.40918V4.39233L5.55819 4.26489L3.96986 5.28662Z"
      fill={color || '#FF360A'}
    />
  </svg>
);
